// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@conklin/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@conklin/Overrides/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { css } from "styled-components";

filterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

filterStyles.datesContainer = {
    gap: 20,
};

filterStyles.orderTotalContainer = {
    gap: 20,
};

filterStyles.clearFiltersLink = {
    ...myAccountFilterSectionStyles.clearFiltersLink,
};

filterStyles.orderTotalAmountTextField = {
    ...myAccountFilterSectionStyles.orderTotalAmountTextField,
};

filterStyles.shipToGridItem = {
    width: [12, 12, 6, 2, 2],
};

filterStyles.orderNumberGridItem = {
    width: [12, 12, 6, 2, 2],
};

filterStyles.buttonsItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
    `,
};

filterStyles.orderTotalGridItem = {
    width: [12, 12, 12, 4, 4],
};

filterStyles.orderTotalOperatorGridItem = {
    width: [12, 12, 6, 6, 6],
};

filterStyles.orderTotalAmountGridItem = {
    width: [12, 12, 6, 6, 6],
};

filterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};

filterStyles.datesGridItem = {
    width: [12, 12, 12, 4, 4],
};

filterStyles.fromGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

filterStyles.toGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

filterStyles.fromDate = {
    ...myAccountFilterSectionStyles.fromDate,
};

filterStyles.toDate = {
    ...myAccountFilterSectionStyles.toDate,
};
